module.exports = __webpack_public_path__ + "public/Icons/childIcon.svg?c7cdbe44";